import apiInstance from "service/axiosConfigure";
import {
  GET_FORM_DATA,
  POST_FORM,
  GET_JOB_POSTINGS,
  GET_JOB_DETAILS,
  GET_CANDIDATE_BY_EMAIL,
  GET_CANDIDATE_BY_PHONE,
} from "service/endpoints";

export const getFormData = async () => {
  return await apiInstance.get(GET_FORM_DATA);
};

export const postForm = async (formData) => {
  return await apiInstance.post(POST_FORM, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getJobPostings = async () => {
  return await apiInstance.get(GET_JOB_POSTINGS);
};

export const getJobDetails = async (id) => {
  return await apiInstance.get(GET_JOB_DETAILS + "/" + id);
};
export const getExistingCandidateByEmail = async (email) => {
  return await apiInstance.get(
    `${GET_CANDIDATE_BY_EMAIL}?email=${encodeURIComponent(email)}`
  );
};

export const getExistingCandidateByPhone = async (phoneNumber) => {
  return await apiInstance.get(
    `${GET_CANDIDATE_BY_PHONE}?phoneNumber=${phoneNumber}`
  );
};
